import { PredicateValue } from '../generated/types';

export function toPredicateValue(
    value: boolean | string | PredicateValue | null | undefined,
    defaultValue: PredicateValue
): PredicateValue;

export function toPredicateValue(
    value: boolean | string | PredicateValue | null | undefined,
    defaultValue?: PredicateValue | undefined
): PredicateValue | undefined;

export function toPredicateValue(
    value: boolean | string | PredicateValue | null | undefined,
    defaultValue?: PredicateValue | undefined
): PredicateValue | undefined {
    if (typeof value === 'boolean') {
        return value ? PredicateValue.Yes : PredicateValue.No;
    }
    if (typeof value === 'string') {
        const normalizedValue = value.trim().toUpperCase();
        if (normalizedValue.length === 0) return defaultValue;
        if (
            'YES'.startsWith(normalizedValue) ||
            'TRUE'.startsWith(normalizedValue)
        )
            return PredicateValue.Yes;
        if (
            'NO'.startsWith(normalizedValue) ||
            'FALSE'.startsWith(normalizedValue)
        )
            return PredicateValue.No;
        if ('UNDECIDABLE'.startsWith(normalizedValue))
            return PredicateValue.Undecidable;
        if ('INDETERMINATE'.startsWith(normalizedValue))
            return PredicateValue.Indeterminate;
        return defaultValue;
    }

    return defaultValue;
}
